/**
 * @Author: Caven
 * @Date: 2020-06-05 16:01:22
 */

const compass_outer = `
<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 64C53.2548 64 64 53.2548 64 40C64 26.7452 53.2548 16 40 16C26.7452 16 16 26.7452 16 40C16 53.2548 26.7452 64 40 64Z" fill="#22293A"/>
<path d="M38 5V11H38.916V6.4874H38.9496L42.0504 11H42.9412V5H42.0252V9.46218H41.9916L38.9244 5H38Z" fill="#E2E5E8"/>
<rect opacity="0.8" x="3" y="40" width="8" height="1" fill="#5D5D62"/>
<rect opacity="0.8" x="68" y="40" width="8" height="1" fill="#5D5D62"/>
<rect opacity="0.8" x="40" y="76" width="8" height="1" transform="rotate(-90 40 76)" fill="#5D5D62"/>
<circle cx="65" cy="20" r="1" fill="#E2E5E8"/>
<circle cx="65" cy="60" r="1" fill="#E2E5E8"/>
<circle cx="15" cy="60" r="1" fill="#E2E5E8"/>
<circle cx="15" cy="20" r="1" fill="#E2E5E8"/>
</svg>

`;

export default compass_outer;
